import Row from "@amzn/meridian/row"
import Tile from "@amzn/meridian/tile"
import Metric from "@amzn/meridian/metric"
import Heading from "@amzn/meridian/heading"
import Text from "@amzn/meridian/text"
import ExtendedPracticeCase from "../../../types/ExtendedPracticeCase";

type propType = {
    practiceCases: ExtendedPracticeCase[]
}

const AggregatedData = (props: propType) => {
    const { practiceCases } = props

    let totalScore: number = 0
    let correctAnswers = 0
    let totalAnswers = 0

    for (const practiceCase of practiceCases) {
        if (practiceCase.trainerAction && practiceCase.trainerAction !== '-') {
            ++totalAnswers
            totalScore += parseFloat(practiceCase.finalScore as string)
            if (practiceCase.finalActionMatch) {
                ++correctAnswers
            }
        }
    }

    const tiles = [
        {
            label: 'Practiced Cases',
            value: practiceCases.length
        },
        {
            label: 'Total AR',
            // null (rendered as '-') when no case has a completed trainer case yet, instead of 0/0 = NaN
            value: totalAnswers === 0 ? null : (correctAnswers / totalAnswers) * 100
        },
        {
            label: 'Avg Score',
            value: totalAnswers === 0 ? null : totalScore / totalAnswers
        }
    ]

    return (
        <Row
            widths={['grid-3', 'grid-3', 'grid-3']}
            spacing='medium'
            spacingInset='xsmall'
        >
        {
            tiles.map((tile, index) => {
                return (
                    <Tile spacingInset="450" key={ index }>
                            <Heading level={2} type="h200" color="secondary">
                            { tile.label }
                            </Heading>
                            {
                                // Metric coerces its child with Number(), so '-' would render as "NaN"
                                tile.value === null
                                ?   <Text type="d100">-</Text>
                                :   <Metric numberFormat={{ maximumSignificantDigits: 3, notation: "compact" }}>
                                    { tile.value }
                                    </Metric>
                            }
                    </Tile>
                )
            })
        }
        </Row>
    )
}

export default AggregatedData